type Opener = () => void;

let opener: Opener | null = null;

export function setAboutOpener(fn: Opener | null): void {
  opener = fn;
}

export function openAbout(): void {
  opener?.();
}
